import HelpSubMenuItems from '@popup/steem/pages/app-container/settings/help-sub-menu/help-sub-menu-items';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { MenuComponent } from 'src/common-ui/menu/menu.component';
const HelpSubMenu = ({}) => {
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_HELP}-page`, className: "settings-help-sub-menu-page" },
        React.createElement(MenuComponent, { title: "popup_html_help", isBackButtonEnable: true, menuItems: HelpSubMenuItems })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const HelpSubMenuComponent = connector(HelpSubMenu);
